'use client';

import type { ProductInformation, RecentProduct } from '@dealerportal/common';
import { useCallback, useState } from 'react';
import {
  ClientContext,
  type ClientContextProps,
} from '../hooks/useClientContext';

export function ClientContextProvider(
  props: Omit<ClientContextProps, 'addRecentProduct' | 'recentProducts'> & {
    children: React.ReactNode;
  }
) {
  const [recentProducts, setRecentProducts] = useState<RecentProduct[]>(
    typeof window !== 'undefined' && localStorage.getItem('recentProducts')
      ? JSON.parse(localStorage.getItem('recentProducts') as string)
      : []
  );
  const addRecentProduct = useCallback((product: ProductInformation) => {
    setRecentProducts((prevRecentProducts) => {
      const foundIndex = prevRecentProducts.findIndex(
        (p) => p.UPID === product.UPID
      );

      const newRecentProducts = [...prevRecentProducts];

      if (foundIndex > -1) {
        newRecentProducts.splice(foundIndex, 1);
      }

      newRecentProducts.unshift({
        UPID: product.UPID,
        slug: product.slug,
        sku: product.sku,
        lastViewedDate: new Date(),
      });

      if (newRecentProducts.length > 20) {
        newRecentProducts.pop();
      }

      localStorage.setItem('recentProducts', JSON.stringify(newRecentProducts));

      return newRecentProducts;
    });
  }, []);

  return (
    <ClientContext.Provider
      value={{ ...props, recentProducts, addRecentProduct }}
    >
      {props.children}
    </ClientContext.Provider>
  );
}
